export default {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    TERTIARY: "tertiary",
    HIGHLINE: "highline",
    HIGHLINE_SECONDARY: "highline_secondary",
    QUATERNARY: "quaternary"
}
